<template>
  <div class="category-keyword-list">
    <div class="title">{{ category.name }}</div>
    <ul class="keyword-list">
      <li v-bind:key="k.id" v-for="k in category.keywords">
        <Keyword>
          {{ k.value }}
        </Keyword>
      </li>
    </ul>
  </div>
</template>

<script>
import Keyword from '@/components/page-keywords/Keyword';

export default {
  name: 'Category',
  components: {
    Keyword,
  },
  props: {
    category: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  border-bottom: solid 1px $color-border;
  color: $color-normal;
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 20px;
  padding-bottom: 14px;
}

.keyword-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 784px) {
  .title {
    font-size: 20px;
  }
  .category-keyword-list {
    padding-bottom: 32px;
  }
}
</style>
